/* istanbul ignore file */

import LazySizes from 'lazysizes';

import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import {
  LAZY_LOAD_CLASSNAME,
  LAZY_LOADING_CLASSNAME,
  LAZY_LOADED_CLASSNAME,
} from 'constants/lazyLoading';

// Lazysizes import is side-effectful, and this configuration needs to happen right after importing it https://github.com/aFarkas/lazysizes/issues/410
// Without these LazySizes imports and configuration, our images won't be able to load on our site
Object.assign(LazySizes.cfg, {
  lazyClass: LAZY_LOAD_CLASSNAME,
  loadingClass: LAZY_LOADING_CLASSNAME,
  loadedClass: LAZY_LOADED_CLASSNAME,
  loadMode: 2,
});

document.addEventListener('lazybeforeunveil', e => {
  const bg = e.target.getAttribute('data-bg');

  if (bg) {
    e.target.style.backgroundImage = `url(${bg})`;
  }
});
